module.exports = __webpack_public_path__ + "img/account-secure.3edb9a63.svg";